export const getAnchorInfo = (link: string) => {
  const hasAnchorLink = link && link.includes('#')
  const anchorInfo = link && link.includes('#') && link.split('#')
  const anchorUrl = (anchorInfo && anchorInfo[0]) || ''
  const anchorId = (anchorInfo && anchorInfo[1]) || ''
  return { hasAnchorLink, anchorInfo, anchorUrl, anchorId }
}
